import { Skull, ShoppingCart, BadgeCheck, User } from "lucide-react";
import { useCart } from "@/lib/cart";
import { scrollToId } from "@/lib/scroll";

const LINKS = [
  { label: "Story", href: "#story" },
  { label: "Titles", href: "#titles" },
  { label: "Art", href: "#gallery" },
  { label: "Fans", href: "#fans" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar({ verified }) {
  const { count, setOpen } = useCart();
  return (
    <header className="fixed top-0 inset-x-0 z-40 border-b-2 border-border bg-void/70 backdrop-blur-xl">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 h-16 flex items-center justify-between gap-4">
        <button
          data-testid="navbar-brand-logo"
          onClick={() => scrollToId("#top")}
          className="flex items-center gap-2 group"
        >
          <img src="/covers/atrocity-logo.webp" alt="Atrocity Comix logo" className="h-7 w-7 rounded-full transition-transform duration-200 group-hover:rotate-12" />
          <span className="font-display text-sm sm:text-base text-paper tracking-wide">
            ATROCITY <span className="text-crimson">COMIX</span>
          </span>
        </button>
        <nav className="hidden lg:flex items-center gap-6">
          {LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-${l.label.toLowerCase()}-link`}
              onClick={() => scrollToId(l.href)}
              className="font-impact uppercase text-xs tracking-widest text-paper/70 transition-colors duration-150 hover:text-crimson"
            >
              {l.label}
            </button>
          ))}
          <a
            data-testid="nav-submissions-link"
            href="/submissions"
            className="font-impact uppercase text-xs tracking-widest text-paper/70 transition-colors duration-150 hover:text-crimson"
          >
            Submissions
          </a>
        </nav>
        <div className="flex items-center gap-3">
          {verified && (
            <span className="hidden sm:flex items-center gap-1 font-marker text-xs text-cyanx -rotate-2">
              <BadgeCheck size={14} /> 18+ VERIFIED
            </span>
          )}
          <a
            data-testid="nav-account-link"
            href="/account"
            className="p-2 text-paper transition-colors duration-150 hover:text-crimson"
            aria-label="Your account"
          >
            <User size={22} />
          </a>
          <button
            data-testid="nav-cart-trigger"
            onClick={() => setOpen(true)}
            className="relative p-2 text-paper transition-colors duration-150 hover:text-yell"
            aria-label="Open cart"
          >
            <ShoppingCart size={22} />
            {count > 0 && (
              <span className="absolute -top-1 -right-1 bg-crimson text-white font-impact text-[10px] w-5 h-5 flex items-center justify-center rounded-full border border-black">
                {count}
              </span>
            )}
          </button>
          <a
            data-testid="nav-explore-shop-button"
            href="/shop"
            className="hidden sm:block font-impact uppercase tracking-wider text-xs bg-blooddeep text-white border-2 border-black px-4 py-2 ink-shadow-sm crimson-glow animate-float transition-colors duration-150 hover:bg-crimson active:translate-x-0.5 active:translate-y-0.5"
          >
            Explore Shop
          </a>
        </div>
      </div>
    </header>
  );
}
